import { render } from "./Abbonamenti.vue?vue&type=template&id=5074f07b"
import script from "./Abbonamenti.vue?vue&type=script&lang=js"
export * from "./Abbonamenti.vue?vue&type=script&lang=js"
script.render = render

export default script